import { AuthToken, onLogout } from '../../lib/auth/auth-store';
import axios from 'axios';

function createApiClient(config: {
  baseURL: string;
  getToken?: () => string | null;
  refreshToken?: () => Promise<string | null>;
  onLogout?: () => void;
}) {
  const client = axios.create({ baseURL: config.baseURL });

  client.interceptors.request.use(req => {
    
    const token = config.getToken?.();
    if (token) req.headers.Authorization = `Bearer ${token}`;
    return req;
  });


  client.interceptors.response.use(
    res => res,
    async error => {
      if (error.response?.status === 401) {
        config.onLogout?.();
      }

      return Promise.reject(error);
    }
  );

  return client;
}

const token = AuthToken();
export const ApiClient = createApiClient({
  baseURL: process.env.REACT_APP_API_BASE_URL || '',
  getToken: () => token,
  refreshToken: async () => {
    return null;
  },
  onLogout: () => {
    onLogout();
  },
});